import { REGEX } from "./services/utility";
import { Alert } from "./services/components";

let isApiCall = false;

function service(data) {
  return $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/api/utility/bloggerInfo",
    data: JSON.stringify(data),
  });
}

const headerBanner = function () {
  const form = document.getElementById("form-header-banner");
  if (form) {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const name = document.getElementById("modal-name");
      const email = document.getElementById("modal-email");
      const facebookPage = { value: "" };
      // document.getElementById('modal-facebook-page');
      const twitterHandle = { value: "" }; // document.getElementById('modal-twitter-handle');
      const instagramHandle = { value: "" }; // document.getElementById('modal-instagram-handle');
      const linkedinProfile = { value: "" }; // document.getElementById('modal-linkedin-profile');
      const youtubeChannel = { value: "" }; // document.getElementById('modal-youtube-channel');
      const personalBlog = document.getElementById("modal-personal-blog");

      if (!email || !REGEX.email.test(email.value) || !email.value) {
        Alert.error("Please enter the email address.");
        return;
      }

      const bannerObj = {
        name: name.value,
        email: email.value,
        facebook: facebookPage.value,
        twitter: twitterHandle.value,
        instagram: instagramHandle.value,
        linkedin: linkedinProfile.value,
        youtube: youtubeChannel.value,
        blog: personalBlog.value,
      };

      if (!isApiCall) {
        isApiCall = true;
        service(bannerObj)
          .done(() => {
            isApiCall = true;

            name.value =
              email.value =
              facebookPage.value =
              twitterHandle.value =
              instagramHandle.value =
              youtubeChannel.value =
              personalBlog.value =
                "";
            document.getElementById("modal-close").click();
            Alert.success(
              "Thank you for your interest! One of our team members will contact you via email for the next steps. Since we are vetting each profile manually, kindly expect some delays.",
            );
          })
          .fail(() => {
            isApiCall = true;
            Alert.error(
              "We couldn't send that right now. Please try again in a moment.",
            );
          });
      }
    });
  }
};

export default headerBanner;
